import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '../components/HelloWorld'
// import  testComponent from  '../components/TestComponent'
import indexPage from '../page/HomePage'
import aboutme from '../page/Aboutme'
import career from '../page/Career'
import linkTo from '../page/Linkto'
import enterpriseDynamics from '../page/EnterpriseDynamics'
import news from '../page/News'
import newDetail from '../page/News/NewsDetail'
import careerDetail from '../page/Career/Detail'
import publicInfoOpen from '../page/PublicInfoOpen'
import publicInfo from '../page/PublicInfo'
Vue.use(Router)
export default new Router({
  routes: [{
    path: '/',
    component: indexPage
  }, {
    path: '/aboutme',
    component: aboutme
  }, {
    path: '/enterpriseDynamics',
    component: enterpriseDynamics
  }, {
    path: '/news',
    component: news
  }, {
    path: '/newDetail',
    component: newDetail
  }, {
    path: '/career',
    component: career
  }, {
    path: '/careerDetail',
    component: careerDetail
  }, {
    path: '/linkto',
    component: linkTo
  },{
    path:'/publicInfoOpen',
    component:publicInfoOpen
  },{
    path:'/publicInfo',
    component:publicInfo
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js